export default {
  // SEO Meta
  siteTitle: 'AllChinaBuy Spreadsheet — Products, Sellers & Smarter Buying Guides',
  siteDescription: 'Explore AllChinaBuy spreadsheet resources, product finds, seller guides, QC information, shipping costs, reviews and practical China shopping guides — all organized in one place.',
  siteKeywords: 'AllChinaBuy, AllChinaBuy spreadsheet, AllChinaBuy review, China shopping, replica spreadsheet, AllChinaBuy guide',

  // Navigation
  navHome: 'Home',
  navShoppingGuide: 'Shopping Guide',
  navCategories: 'Categories',
  navSpreadsheet: 'Spreadsheet',
  navProducts: 'Products',
  navSellers: 'Sellers',
  navGuides: 'Guides',
  navReviews: 'Reviews',
  navShipping: 'Shipping',
  navQC: 'QC',
  navCoupons: 'Coupons',
  navAbout: 'About',
  navContact: 'Contact',

  // Hero
  heroH1: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Smarter Buying Guides',
  heroSub: 'Explore AllChinaBuy spreadsheet resources, product finds, seller guides, QC information, shipping costs, reviews and practical China shopping guides — all organized in one place.',
  ctaExplore: 'Explore AllChinaBuy Spreadsheet',
  ctaBuyNow: 'Buy It Now',
  ctaReview: 'Read Full Review',
  ctaVisit: 'Visit Main Website',
  ctaMain: 'AllChinaBuy Spreadsheet',

  // Categories
  categoryTitle: 'Browse Categories',
  categorySubtitle: 'Find exactly what you need across our curated spreadsheet collections',
  categories: [
    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
    { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
    { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
    { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
    { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
    { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
    { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
    { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
    { name: 'Belts', url: 'https://kaspreadsheet.com/category-922-Belts.html' },
    { name: 'Perfumes', url: 'https://kaspreadsheet.com/category-923-Perfumes.html' },
    { name: 'Other Stuff', url: 'https://kaspreadsheet.com/category-924-Other+Stuff.html' },
  ],

  // Articles
  articleTitle: 'AllChinaBuy Spreadsheet Guides & Articles',
  articleSubtitle: 'In-depth resources to help you navigate AllChinaBuy like a pro',
  readMore: 'Read More',
  article1Title: 'AllChinaBuy Spreadsheet 2026: Complete Guide for Smart Buyers',
  article1Desc: 'Discover how to use the AllChinaBuy spreadsheet to find the best products, trusted sellers, and save money on your China shopping journey.',
  article1Meta: 'Updated August 2026 · 8 min read',
  backToHome: 'Back to Home',
  relatedArticles: 'Related Articles',
  shareArticle: 'Share This Guide',

  // Footer
  footerDisclaimer: 'AllChinaBuySpreadsheet.best is an independent informational resource and is not affiliated with or endorsed by AllChinaBuy.',
  footerLinks: 'Quick Links',
  footerLegal: 'Legal & Safety',
  footerPrivacy: 'Privacy Policy',
  footerTerms: 'Terms of Use',
  footerEditorial: 'Editorial Policy',
  footerSafety: 'Safety Guide',
  footerCopyright: '© 2026 AllChinaBuySpreadsheet.best. All rights reserved.',
  footerLanguage: 'Language',

  // Article page
  articleIntro: 'Introduction',
  articleTOC: 'Table of Contents',
  articleConclusion: 'Conclusion',
  articleCTA: 'Ready to start shopping smarter?',
  articleCTABtn: 'Explore AllChinaBuy Spreadsheet',
  articleInternalLink: 'Return to our AllChinaBuy Spreadsheet homepage for more resources and buying guides.',

  // Dropdown
  selectCategory: 'Select a Category',
  browseAll: 'Browse All Categories',

  // Trust signals
  trustIndependent: 'Independent Resource',
  trustVerified: 'Verified Information',
  trustUpdated: 'Regularly Updated',
  trustCommunity: 'Community Driven',
};